import { type Value } from '@discover-use-router-state';
import DEFAULT_HAS_LAST_TABLE from '@discover-data/stores/restaurant/model/hasLastTable/default';

export default function getValidHasLastTable(routerValues: Value[]): boolean {
  if (routerValues.length === 0) {
    return DEFAULT_HAS_LAST_TABLE;
  }

  const value = routerValues[0];

  if (value === undefined || value === null) {
    return DEFAULT_HAS_LAST_TABLE;
  }

  if (value === 'true' || value === 'false') {
    return value === 'true';
  }

  return DEFAULT_HAS_LAST_TABLE;
}
